export enum loginSteps {
  login = "login",
  forgot = "forgot",
  code = "code",
  confirm = "confirm",
}
